import { useIsRoute } from '@/hooks/useIsRoute'
import { ROUTES } from '@/lib/routes'

export function useShouldShowAdditionalCompanyInfo() {
  const isRoute = useIsRoute()
  const isCompanyProfilePage = isRoute(ROUTES._companyProfile)
  const isAddRelationshipPage = isRoute(ROUTES._addRelationship)

  return isCompanyProfilePage || isAddRelationshipPage
}
